/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import { rectSortingStrategy } from '@dnd-kit/sortable';
import InputAdornment from '@material-ui/core/InputAdornment';
import _ from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import * as actions from '../../actions/index';
import { UNIT } from '../../constants/theme';
import Input from '../Input';
import Select from '../Select';
import Modal from '../Modal';
import DraggableImage from '../DraggableImage';
import IconButton from '../IconButton';
import SortableList from '../SortableList';
import { checkAccess } from '../../utils/admins';
import { styles } from './ProductList.styles';
import { returnCategories, getOriginalCategories } from '../../utils/product';
import {
  handleRemoveProduct,
  handleNewProduct,
  addOption,
  handleProduct,
  handleSubmitProduct,
  handleRemoveImage,
  setCroppedImage,
  handleChange,
  handleStartDrag,
  handleChangeNumber,
  handleDragProduct,
  updateAvailableProduct,
  handleDuplicateProduct,
  handleChangeOrderTypes,
  handleRemoveProductSubmit,
  handleDragMove, canUseSplashPrice,
  setImageConfig
} from './ProductList.services';
import { getOrderTypes, getShopsToSynchronise, handleSynchronisationToggle } from '../../utils/shopUtils';
import CardItem from '../CardItem';
import OptionListCheckbox from '../OptionListCheckbox';
import Checkbox from '../Checkbox';
import ShopModal from '../ShopModal';
import { SUITABLE_ORDER_TYPES, CUSTOM_INTEGREDIENT } from '../../constants';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';
import MenuSelect from '../MenuSelect'
import { getFiltredCategories } from '../OptionModal/OptionModal.services';
import { isStringNotNull } from 'src/utils/tools';
const MenuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
};
const MuiMenuItem = withStyles({
  root: {
    '&.Mui-selected': {
      backgroundColor: '#FFFFFF'
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: '#FFFFFF'
    }
  }
})(MenuItem);
const INITIAL_STATE = {
  isLoading: true,
  item: '',
  sectionKey: '',
  categoriesArray: [],
  categoriesSelected: [],
  productModalOpen: false,
  updateProductModalOpen: false,
  removeProductModal: false,
  removeSectionModal: false,
  synchronize: false,
  product: {},
  section: {},
  activeId: null,
  disabledOrderTypes: [],
  picture: {},
  isSorting: false,
  showModal: false,
  selectedShops: {},
  isSuppression: false
};
class ProductList extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }
  componentDidMount() {
    this.setState({ mounted: true })
  }

  componentWillUnmount() {
    this.setState({ mounted: false })
  }

  renderOrderTypes = () => {
    const { disabledOrderTypes } = this.state;
    const { classes, orderTypes } = this.props;
    const orderTypesPriority = _.filter(Object.keys(SUITABLE_ORDER_TYPES), type => orderTypes?.includes(type))
    return (
      <Select
        as='select'
        custom
        className='w-100'
        label='Désactiver la vente de ce produit pour le mode'
        multiple
        displayEmpty
        value={getOrderTypes(orderTypesPriority).filter(value => disabledOrderTypes.includes(value))}
        onChange={event => handleChangeOrderTypes(event, this)}
        renderValue={selected => {
          if (selected.length === 0) {
            return <span> À choisir</span>;
          }
          return selected.join(', ');
        }}
        MenuProps={MenuProps}
      >
        {getOrderTypes(orderTypesPriority).map(orderType => (
          <MuiMenuItem key={orderType} value={orderType} className={classes.text}>
            <Checkbox
              value={disabledOrderTypes.indexOf(orderType) > -1}
              text={orderType}
              name={orderType}
            />
          </MuiMenuItem>
        ))}
      </Select>
    );
  };

  renderUpdateDialogProduct = () => {
    const {
      product = {},
      categoriesArray = [],
      updateProductModalOpen,
      productModalOpen,
      isLoadingProduct,
      productName,
      synchronize
    } = this.state;
    const { classes, categories, shops, shopId, sectionsPOS, sectionKey, categoriesPOS } = this.props;
    const { name = '', price = '', description = '', ref = '', image = [], imageCompressed, preparationTime, categories: productCategories, key } = product;
    const hasMenuPOS = checkIntegrationAccess('products', 'hasMenuPOS')
    const selectedCategories = returnCategories(productCategories, categories);
    const sectionWithPOS = CUSTOM_INTEGREDIENT.includes(sectionKey) ? sectionsPOS : _.omit(sectionsPOS, CUSTOM_INTEGREDIENT);
    const originalCategories = getOriginalCategories(sectionWithPOS, ref, categories)
    const isSplash = canUseSplashPrice(product)
    const selectedImage = isStringNotNull(imageCompressed) ? imageCompressed : image;
    const picture = Array.isArray(selectedImage)
      ? selectedImage
      : [{ imageUrl: selectedImage }];
    return (
      <Modal
        color='secondary'
        title={productModalOpen ? 'Nouveau produit' : `Modifier le produit ${productName}`}
        subTitle={key && `(${key})`}
        btnTxt='Enregistrer'
        handleClose={() => {
          if (productModalOpen || updateProductModalOpen) {
            this.setState({ productModalOpen: false, updateProductModalOpen: false, synchronize: false, isSuppression: false });
          } else {
            this.setState({ productModalOpen: true, updateProductModalOpen: true, synchronize: false, isSuppression: false });
          }
        }}
        header
        loading={!synchronize && isLoadingProduct}
        size='lg'
        showCancelBtn
        modalBodyClass='py-0'
        isOpen={productModalOpen || updateProductModalOpen}
        onClick={() => {
          synchronize ?
            this.setState({
              selectedShops: { [shopId]: shops[shopId] },
              showModal: true,
            }) :
            handleSubmitProduct(this, {}, selectedCategories)
        }}
        fixed
      >
        <div className={classes.modalStyle}>
          <div className={hasMenuPOS && !product.name && classes.disabled}>
            <DraggableImage
              multiple={false}
              maxFileSize={500000}
              aspect={1.25}
              imgExtension={['.png', '.jpeg', '.jpg']}
              picture={picture}
              defaultText={"Drag & Drop l'image (500Ko max)"}
              setCroppedImage={croppedImage => setCroppedImage(croppedImage, this)}
              setImageConfig={imageConfig => setImageConfig(imageConfig, this)}
              saveConfigOnly
              handleRemove={() => handleRemoveImage(this)}
            />
          </div>
          {hasMenuPOS &&
            <MenuSelect data={sectionWithPOS}
              placeholder='Produit de la caisse'
              item={product}
              onUpdate={(item) => this.setState({ product: { ...item, key: item.key }, categoriesArray: returnCategories(item.categories, categoriesPOS) })}
              disabled={!productModalOpen}
              noOptionsText="Aucun produit trouvé" itemKey="sectionName" />}

          <div style={{ width: '100%' }}>
            <Input
              margin='dense'
              id='name'
              label='Nom'
              type='text'
              value={name}
              onChange={e => handleChange(e, this)}
              fullWidth
            />
            {hasExternalIntegration() && (
              <Input
                margin='dense'
                fullWidth
                id='ref'
                label='Référence du produit'
                value={ref}
                onChange={e => handleChange(e, this)}
                disabled={checkIntegrationAccess('products', 'disableRefs')}
              />
            )}
            <Input
              margin='dense'
              id='description'
              label='Description du produit'
              type='text'
              value={description}
              onChange={e => handleChange(e, this)}
              fullWidth
            />

            <Input
              margin='dense'
              id='price'
              label={<><span>Prix de vente</span>
                {isSplash && product?.priceRef > 0 && <span className={classes.priceStyle}>(Doit être inférieur ou égal à {product?.priceRef} €)</span>}</>}
              type='number'
              value={price}
              onChange={e => handleChangeNumber(e, this)}
              InputProps={{
                startAdornment: <InputAdornment position='start'>€</InputAdornment>
              }}
              error={isSplash && price > product?.priceRef}
              fullWidth
              disabled={checkIntegrationAccess('products', 'disablePrice') || ref === '$' || product?.priceRef === 0}
            />

            <Input
              margin='dense'
              id='preparationTime'
              label='Temps de préparation'
              type='number'
              className='w-100'
              fullWidth
              classes={{
                label: classes.labelStyle
              }}
              value={preparationTime}
              onChange={e => handleChangeNumber(e, this)}
              InputProps={{
                startAdornment: <InputAdornment position='start'>h</InputAdornment>
              }}
            />

            <div className='mb-1 mt-2 w-100'>{this.renderOrderTypes()}</div>
            <div className='w-100'>
              <OptionListCheckbox
                categoriesArray={categoriesArray}
                addOption={(categoryKey, index) =>
                  addOption(categories[categoryKey].name, categoryKey, index, this)
                }
                categories={getFiltredCategories(categories, product?.type, ref)}
                disableOption={checkIntegrationAccess('products', 'disableOptionList')}
                selectedCategories={selectedCategories}
                productCategories={productCategories}
                originalCategories={originalCategories}
              />
            </div>
          </div>
          {checkAccess('features', 'globalProduct') && (
            <Checkbox
              value={synchronize}
              name='synchronize'
              text='Synchroniser ce produit sur un ou plusieurs magasins'
              onClick={() => this.setState({ synchronize: !synchronize })}
              hidden={_.size(getShopsToSynchronise()) === 1}
            />
          )}
        </div>
      </Modal>
    );
  };

  renderProductItem = (productKey, handleProps) => {
    const { classes, categories: allCategories, products = {} } = this.props;
    const { isSorting } = this.state;
    const product = products[productKey];
    if (product) {
      const { categories, preparationTime } = product;
      const categoriesArray = returnCategories(categories, allCategories);
      return (
        <div {...handleProps} className="product" data-product-key={productKey}>
          <CardItem
            key={productKey.toString()}
            isProduct
            item={product}
            onClick={() =>
              !isSorting &&
              checkAccess('features', 'productAndOption') &&
              handleProduct(categoriesArray, product, this)
            }
            onRemove={() => { handleRemoveProduct(product, this); this.setState({ isSuppression: true, synchronize: false }) }}
            onChange={() => updateAvailableProduct(productKey, product, this)}
            onDuplicate={() => handleDuplicateProduct(product, this)}
            body={
              <div className={classes.body}>
                <p className={classes.textStyle}>
                  Produit vendu à l'unité
                </p>
                <p className={classes.textStyle} style={{ marginTop: 0 }}>
                  {`Temps de préparation: ${preparationTime ? `${preparationTime}h` : '--'} `}
                </p>
                <div style={{ height: UNIT * 1.875 }}>
                  <p className='truncText ' style={{ fontSize: UNIT * 0.625, color: '#646777' }}>
                    {`Option(s) associée(s): ${' '}
                ${(categoriesArray.length > 0 &&
                        categoriesArray.map(category => {
                          const { name } = category;
                          return ` ${name}`;
                        })) ||
                      '--'}`}
                  </p>
                </div>
              </div>
            }
          />
        </div>
      );
    }
    return true;
  };

  renderShops = (classes, shopId) => {
    const { showModal, selectedShops = {}, isLoadingProduct, productKey = '', isSuppression, product = {} } = this.state;
    const selectedCategories = returnCategories(product?.categories, this.props.categories);
    return (
      <ShopModal
        classes={classes}
        shopId={shopId}
        showModal={showModal}
        selectedShops={selectedShops}
        loading={isLoadingProduct}
        onClick={() => isSuppression ? handleRemoveProductSubmit(productKey, this) : handleSubmitProduct(this, selectedShops, selectedCategories)}
        handleToggle={handleSynchronisationToggle}
        component={this}
        text={`Sélectionnez les magasins dont vous voulez ${isSuppression ? 'supprimer' : 'synchroniser'} ce produit:`}
        title={`${isSuppression ? 'Supprimer' : 'Synchroniser'} votre produit:`}
        isSuppression={isSuppression}
      />
    );
  };
  render() {
    const { activeId = null, showModal } = this.state;
    const { classes, products = {}, shopId } = this.props;
    const sortedProducts = _.keys(products)
      .sort((a, b) => products[a].position - products[b].position)
      .reduce((obj, cur) => ({ ...obj, [cur]: products[cur] }), {});
    return (
      <div className={classes.body}>
        <Grid container spacing={1} className={classes.container}>
          <div
            aria-hidden='true'
            role='button'
            className={classes.firstItem}
            onClick={e =>
              checkAccess('features', 'productAndOption') && (!checkIntegrationAccess('products', 'hideCreateProduct')) &&
              handleNewProduct(e, this.props.sectionKey, this)
            }
          >
            <IconButton
              className={classes.addIcon}
              title='Ajouter un produit'
              disabled={!checkAccess('features', 'productAndOption') || checkIntegrationAccess('products', 'hideCreateProduct')}
            >
              <AddIcon className={classes.iconStyle} />
            </IconButton>
          </div>
          <SortableList
            list={sortedProducts}
            activeId={activeId}
            strategy={rectSortingStrategy}
            handleDragEnd={e => handleDragProduct(e, sortedProducts, this)}
            handleDragStart={e => handleStartDrag(e, this)}
            handleDragMove={e => { handleDragMove(e, this) }}
            renderItem={(productKey, handleProps) =>
              this.renderProductItem(productKey, handleProps)
            }
          />
        </Grid>
        {this.renderUpdateDialogProduct()}
        {showModal && this.renderShops(classes, shopId)}
      </div>
    );
  }
}

function mapStateToProps({ user, firebaseRealTime }) {
  const { storageBucket = {}, shopId, nbShops } = user;
  const { shop = {}, generalConfig, shops, menu = {}, menuPOS = {} } = firebaseRealTime;
  const { marketplace = {} } = generalConfig;
  const { configuration = {} } = shop;
  const { sections = {}, categories = {} } = menu
  const { orderTypes } = configuration;
  const { sections: sectionsPOS = {}, categories: categoriesPOS } = menuPOS
  return {
    categories,
    storageBucket,
    sections,
    orderTypes,
    shopId,
    shops,
    nbShops,
    marketplace: marketplace.enabled,
    sectionsPOS, categoriesPOS
  };
}

ProductList.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(ProductList));